@use 'src/global/variables.scss' as var;

:host {
  display: inline-block;
  background-color: var.$ls-user-bubble;
  color: var.$ls-text-color-dark;
  border-radius: 3px;
  font-size: 16px;
}

button {
  color: inherit;
  font-size: inherit;
  width: 100%;
  height: 100%;
  background-color: transparent;
  display: flex;
  align-items: center;
  padding: 1rem;
  border: none;
  cursor: pointer;
  border-radius: inherit;

  &:focus,
  &:hover {
    outline: none;
    box-shadow: 0 0 0 4px var.$ls-focus-color;
  }
}
